// TraditionGame.jsx
import React, { useState } from 'react';
import axios from 'axios';

const TraditionGame = ({ 
  token, 
  clientUuid,
  interfaceUuid, 
  onSuccess, 
  onClose 
}) => {
  const [result, setResult] = useState(null); 
  const [loading, setLoading] = useState(false); 
  const [throwing, setThrowing] = useState(false);
  const [targetusername, setTargetusername] = useState('');
  const [increment, setIncrement] = useState(0);  // 윷 결과(1~5)를 기억하기 위해 추가

  // 윷놀이 범위 (도개걸윷모)
  const items = [
    { name: '도', increment: 1 },
    { name: '개', increment: 2 },
    { name: '걸', increment: 3 },
    { name: '윷', increment: 4 },
    { name: '모', increment: 5 },
  ];

  const playGame = () => {
    setLoading(true);
    setThrowing(true);
    setResult(null);
    setIncrement(0);

    // 3초 동안 "윷을 던지고 있습니다..."
    setTimeout(async () => {
      setThrowing(false);

      try {
        // 1) 도/개/걸/윷/모 랜덤 선정
        const randomIndex = Math.floor(Math.random() * items.length);
        const chosenItem = items[randomIndex];

        // 2) 서버에 tradition support 요청
        const response = await axios.post(
          `/users/${interfaceUuid}/gauge`,
          {
            clientUuid : clientUuid,
            gaugeIncrement: chosenItem.increment,
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );
      
        // target user name 입력
        setTargetusername(response.data.targetusername)

        // 3) 결과 화면 표시
        setResult(chosenItem.name);
        setIncrement(chosenItem.increment);

        // 게이지 갱신이 필요하다면 onSuccess
        if (response.data?.newYearSun) {
          onSuccess(response.data.newYearSun);
        } else {
          alert('Unexpected response from server');
        }
      } catch (error) {
        console.error('Error in tradition support:', error);
        alert('하루 해 높이기 횟수를 초과했습니다 (나의 해 3번 , 다른 사람 해 1번)');
      } finally {
        setLoading(false);
      }
    }, 3000);
  };

  return (
    <div style={{ textAlign: 'center' }}>
      <h2>윷놀이</h2>

      {/* 윷 던지기 버튼 */}
      <button onClick={playGame} disabled={loading}>
        {loading ? '윷을 던지는 중...' : '윷놀이 하기'}
      </button>

      {/* 3초 동안 표시할 로딩 문구 */}
      {throwing && <p>윷을 던지고 있습니다...</p>}

      {/* 결과 출력: 예) "결과: 도" / "홍길동 님의 해를 1 해돋음 높였습니다" */}
      {result && (
        <div style={{ marginTop: '10px' }}>
          <p>결과: <strong>{result}</strong>!</p>
          <p>
            <strong>{targetusername}</strong> 님의 해를{' '}
            <strong>{increment}</strong> 해돋음 높였습니다
          </p>
        </div>
      )}

      {/* 닫기 버튼 (자동으로 안 닫힘) */}
      <button 
        onClick={onClose} 
        style={{ marginTop: '10px' }}
        disabled={loading}
      >
        닫기
      </button>
    </div>
  );
};

export default TraditionGame;
